import { getFeatureFlagValue } from "components/ZFeatureFlag";
import Layout from "layouts/Layout";
import { Accounts } from "pages/admin/Accounts";
import { NewAccount } from "pages/admin/NewAccount";
import { GeneralSync } from "pages/admin/Sync/GeneralSync";
import { NoDashboard } from "pages/dashboard/NoDashboard";
import { DispensePricing } from "pages/dispense/dispensePricing/DispensePricing";
import { DispensePricingList } from "pages/dispense/dispensePricing/DispensePricingList";
import { NewPreferredBrand } from "pages/dispense/preferredBrands/NewPreferredBrand/NewPreferredBrand";
import { PreferredBrands } from "pages/dispense/preferredBrands/PreferredBrands";
import { ErrorPageNotFound } from "pages/error/PageNotFound";
import { ManageGroups } from "pages/management/groups/ManageGroups";
import { Stores } from "pages/management/stores/Stores";

import { AssignPriceGroupOld as AssignPriceGroup } from "pages/multiLevelPricing/assignPriceGroup/AssignPriceGroupOld";

import { NewPriceGroupOld as NewPriceGroup } from "pages/multiLevelPricing/priceGroups/NewPriceGroupOld";
import { PriceGroupOld as PriceGroup } from "pages/multiLevelPricing/priceGroups/PriceGroupOld";
import { Catalogues } from "pages/promotions/catalogues/Catalogues";
import { NewCatalogue } from "pages/promotions/catalogues/NewCatalogue/NewCatalogue";
import { OldCatalogue } from "pages/promotions/catalogues/OldCatalogue/OldCatalogue";
import { GroupTillReport } from "pages/reports/GroupTillReport";
import { Reports } from "pages/reports/Reports";
import { StockReport } from "pages/reports/StockReport";
import { Departments } from "pages/stocks/Departments/Departments";
import { NewDepartment } from "pages/stocks/Departments/NewDepartment/NewDepartment";
import { ManagedStockConflicts } from "pages/stocks/Managed/ManagedStockConflicts";
import { TradingTotalsReport } from "pages/reports/TradingTotalsReport";
import { ManagedStocks } from "pages/stocks/Managed/ManagedStocks";
import { ManagedStocks as OldManagedStocks } from "pages/stocks/ManagedProtable/ManagedStocks";
import { NewStocks } from "pages/stocks/Managed/NewStocks/NewStocks";
import { Manufacturers } from "pages/stocks/Manufacturers/Manufacturers";
import { NewManufacture } from "pages/stocks/Manufacturers/NewManufacturer";
import { NewStockGroup } from "pages/stocks/StockGroups/NewStockGroup";
import { StockGroups } from "pages/stocks/StockGroups/StockGroups";
import { NewSupplier } from "pages/stocks/Suppliers/NewSupplier";
import { Suppliers } from "pages/stocks/Suppliers/Suppliers";
import { Route, Routes } from "react-router";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { ReportViewer } from "pages/reports/reportViewer";
import { GroupStockReport } from "pages/reports/GroupStockReport";
import { StoreLockdownFields } from "pages/management/stores/StoreLockdownFields";
import { SupplierDeals } from "pages/orders/supplierDeals/SupplierDeals";
import { NewSupplierDeal } from "pages/orders/supplierDeals/NewSupplierDeal";
import { NewSupplierGroupDeal } from "pages/orders/supplierGroupDeals/NewSupplierGroupDeal";
import { SupplierGroupDeals } from "pages/orders/supplierGroupDeals/SupplierGroupDeals";
import { StocksCreatedAtStore } from "pages/dashboard/StocksCreatedAtStore";
import { PendingPriceChanges } from "pages/dashboard/PendingPriceChanges";
import { NewDashboard } from "pages/dashboard/NewDashboard";

export function UserRoutes() {
  const user = useAppSelector((state: RootState) => state.logedinUser);
  const global = useAppSelector((state: RootState) => state.global);

  return (
    <div>
      <Layout>
        {!global.loadedFlags ? (
          <Routes>
            <Route path="/*" element={<></>} />
          </Routes>
        ) : (
          <Routes>
            {/* Dashboard */}
            <Route
              path="/dashboards/business"
              element={
                user?.permissions?.dashboard?.canView ? (
                  <NewDashboard dashboardType="business" />
                ) : (
                  <NoDashboard />
                )
              }
            />
           {getFeatureFlagValue(global.featureFlags, "ZFreedom.Dashboards.Operations") === true && <Route
              path="/dashboards/operations"
              element={
                user?.permissions?.dashboard?.canView ? (
                  <NewDashboard dashboardType="operations" />
                ) : (
                  <NoDashboard />
                )
              }
            />}
            {/* Drill downs */}
            <Route path="/stocks-created-at-store" element={<StocksCreatedAtStore />} />
            <Route path="/pending-price-changes" element={<PendingPriceChanges />} />
            {/* Stocks */}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.ManagedStock.AgGrid") === true ? (<Route path="/managed" element={<ManagedStocks />} />) : (<Route path="/managed" element={<OldManagedStocks />} />)}
            <Route path="/new-stock" element={<NewStocks />} />
            <Route path="/stock/:stockId" element={<NewStocks />} />
            <Route path="/stock-conflicts" element={<ManagedStockConflicts />}
            />
            {/* Multi-Level Pricing */}
            <Route path="/price-groups" element={<PriceGroup />} />
            <Route path="/new-price-group" element={<NewPriceGroup />} />
            <Route path="/price-group/:priceGroupId" element={<NewPriceGroup />}
            />
            <Route path="/assign-price-group" element={<AssignPriceGroup />} />
            {/* Suppliers  */}
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/supplier/new" element={<NewSupplier />} />
            <Route path="/supplier/:supplierId" element={<NewSupplier />} />
            {/* Stock deals  */}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.StockDeals") === true && user.permissions.supplierDeals.canView === true && <Route path="/supplier-stock-deals" element={<SupplierDeals />} />}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.StockDeals") === true && user.permissions.supplierDeals.canView === true && <Route path="/supplier-stock-deals/new" element={<NewSupplierDeal />} />}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.StockDeals") === true && user.permissions.supplierDeals.canView === true && <Route path="/supplier-stock-deals/:modelId" element={<NewSupplierDeal />} />}
            {/* Assorted deals  */}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.AssortedDeals") === true && user.permissions.supplierGroupDeals.canView === true && <Route path="/supplier-assorted-deals" element={<SupplierGroupDeals />} />}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.AssortedDeals") === true && user.permissions.supplierGroupDeals.canView === true && <Route path="/supplier-assorted-deals/new" element={<NewSupplierGroupDeal />} />}
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.SupplierDeals.AssortedDeals") === true && user.permissions.supplierGroupDeals.canView === true && <Route path="/supplier-assorted-deals/:modelId" element={<NewSupplierGroupDeal />} />}
            {/* StockGroups */}
            <Route path="/stock-groups" element={<StockGroups />} />
            <Route path="/stock-group/new" element={<NewStockGroup />} />
            <Route path="/stock-group/:stockGroupId" element={<NewStockGroup />}
            />
            {/* Manufacturers */}
            <Route path="/Manufacturers" element={<Manufacturers />} />
            <Route path="/Manufacturer/new" element={<NewManufacture />} />
            <Route path="/Manufacturer/:manufacturerId" element={<NewManufacture />}
            />
            {/* Departments */}
            <Route path="/departments" element={<Departments />} />
            <Route path="/department/new" element={<NewDepartment />} />
            <Route path="/department/:departmentId" element={<NewDepartment />}
            />
            {/* Reports */}
            <Route path="/reports" element={<Reports />} />
            <Route path="/stockreport/:reportId" element={<StockReport />} />
            <Route path="/tillReport/" element={<GroupTillReport />} />
            <Route path="/tradingtotalsReport/" element={<TradingTotalsReport />}
            />
            <Route path="/reportViewer/:reportId" element={<ReportViewer />} />
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.Reports.Group.Stock") === true && (<Route path="/reports/stock-report" element={<GroupStockReport />} />
            )}
            {/* Dispense */}
            <Route path="/dispense-pricing" element={<DispensePricing />} />
            {/* <ProtectedRoute path="/dispense-price/new" element={<DispensePricingList/>} /> */}
            <Route path="/dispense-price/:dispensePricingId" element={<DispensePricingList />}
            />
            <Route path="/preferred-brands" element={<PreferredBrands />} />
            <Route path="/preferred-brand/new" element={<NewPreferredBrand />}
            />
            <Route path="/preferred-brand/:preferredBrandId" element={<NewPreferredBrand />}
            />
            {/* Catalogues */}
            <Route path="/catalogues" element={<Catalogues />} />
            <Route path="/catalogue/new" element={<NewCatalogue />} />
            <Route path="/catalogue/:catalogueId" element={<NewCatalogue />} />
            <Route path="/catalogueView/:catalogueId" element={<OldCatalogue />}
            />
            {/* Management */}
            <Route path="/stores" element={<Stores />} />
            {getFeatureFlagValue(global.featureFlags, "ZFreedom.Stores.LockDownFields") === true && user.permissions.lockDownFields.canView === true && (<Route path="/storeLockDownFields" element={<StoreLockdownFields />} />)}
            <Route path="/groups" element={<ManageGroups />} />
            {/* Accounts */}
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/sync" element={<GeneralSync />} />
            <Route path="/account/:accountId" element={<NewAccount />} />
            <Route path="/new-account" element={<NewAccount />} />
            {/* Error */}
            <Route path="/*" element={<ErrorPageNotFound />} />
          </Routes>
        )}
      </Layout>
    </div>
  );
}
